import React, { useEffect, useState } from "react";
import { Button, Col, Row, Space } from "antd";
import { ThemeFilterBtn, XThemeSelect } from "../../../Styles/Theme";
import { CloseOutlined, LeftOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import { ThemePreviewTabs } from "../../SurveysStyle";
import DesktopPreview, { MobileView, TabletView } from "./QstPreview";
import ChatPreview from "./ChatPreview";

const Preview = () => {
  const navigate = useNavigate();
  const [previewType, setPreviewType] = useState(1);
  return (
    <>
      <ThemePreviewTabs
        defaultActiveKey="1"
        centered
        tabBarExtraContent={{
          left: (
            <>
              <div className="leftWrapper">
                <span>
                  <ThemeFilterBtn
                    size="medium"
                    shape="circle"
                    icon={<LeftOutlined />}
                    className="noBackground mr-2"
                    onClick={() => navigate(-1)}
                  />
                </span>
                Preview
              </div>
            </>
          ),
          right: (
            <>
              <div className="rightWrapper">
                <Space>
                  <span className="draftSaved">
                    <XThemeSelect
                      className="fullWidth noRadius"
                      size="large"
                      shape="square"
                      defaultValue={Number(previewType)}
                      style={{ minWidth: 150 }}
                      name="previewType"
                      onChange={(value) => setPreviewType(value)}
                      options={[
                        { value: 1, label: "All Question" },
                        { value: 2, label: "Conversational" },
                      ]}
                    />
                  </span>
                  <ThemeFilterBtn
                    className="mx-1 mx-sm-3"
                    size="large"
                    shape="circle"
                    iconPosition="end"
                    icon={<CloseOutlined />}
                    onClick={() => navigate(-1)}
                  />
                </Space>
              </div>
            </>
          ),
        }}
        // Preview all questions
        items={[
          {
            key: "1",
            label: <img src="/images/desktop-icon.svg" alt="Editor" />,
            children: (
              <>
                {previewType === 1 && <DesktopPreview />}
                {previewType === 2 && (
                  <>
                    <Row>
                      <Col
                        xs={{ span: 24, offset: 0 }}
                        sm={{ span: 24, offset: 0 }}
                        md={{ span: 16, offset: 4 }}
                      >
                        <ChatPreview />
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ),
          },
          {
            key: "2",
            label: <img src="/images/tablet-icon.svg" alt="Editor" />,
            children: (
              <>
                {previewType === 1 && <TabletView />}
                {previewType === 2 && (
                  <>
                    <Row>
                      <Col
                        xs={{ span: 24, offset: 0 }}
                        sm={{ span: 20, offset: 2 }}
                        md={{ span: 12, offset: 6 }}
                      >
                        <ChatPreview />
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ),
          },
          {
            key: "3",
            label: <img src="/images/mobile-icon.svg" alt="Editor" />,
            children: (
              <>
                {previewType === 1 && <MobileView />}
                {previewType === 2 && (
                  <>
                    <Row>
                      <Col
                        xs={{ span: 24, offset: 0 }}
                        sm={{ span: 20, offset: 2 }}
                        md={{ span: 10, offset: 7 }}
                      >
                        <ChatPreview />
                      </Col>
                    </Row>
                  </>
                )}
              </>
            ),
          },
        ]}
      />
    </>
  );
};

export default Preview;
